import { render, staticRenderFns } from "./CreditHistory.vue?vue&type=template&id=778a87f8&scoped=true&"
import script from "./CreditHistory.vue?vue&type=script&lang=js&"
export * from "./CreditHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778a87f8",
  null
  
)

export default component.exports